export const VAT_RATE = 0.16;

/** Mirrors server/utils/tax.js — given a package's KES/month amount, returns whole-KES breakdown. */
export function withVat(amount) {
  const subtotal = Number(amount);
  const vat = Math.round(subtotal * VAT_RATE);
  return { subtotal, vat, total: subtotal + vat };
}

export function formatKES(amount) {
  return `KES ${Number(amount || 0).toLocaleString()}`;
}

/** Paystack expects the smallest currency unit; this app's KES convention is amount * 100. */
export function toPaystackAmount(totalKes) {
  return Math.round(totalKes * 100);
}

// TEMPORARY: mirrors server/utils/billing.js. The customer sees and is quoted the real
// package price everywhere in this UI, but the actual Paystack charge is capped at this
// amount while the live integration is being tested cheaply. Remove before going live.
export const TEST_CHARGE_AMOUNT_KES = 5;
